import React from 'react';
import Wrapper from './Wrapper';

class FormEmail extends Wrapper {
  static validationRules = {
    error: {
      email: true,
    },
  };

  render() {
    const {classElement, rules, required, fieldApi, label, className, value, children, ...rest} = this.props;

    return (
      <div className={this.getWrapperClass()}>
        {this.renderLabel()}
        {children}
        <input
          type="email"
          className={this.getElementClass()}
          value={this.getValue()}
          {...rest}
          onChange={this.onChange}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
        />
        {this.renderMessage()}
      </div>
    );
  }
}

export default FormEmail;
